import AdornmentValidator from './AdornmentValidator';

export default AdornmentValidator;
